import React, {FC} from 'react'
import {Autocomplete, Checkbox, Input} from "../../../ui-components";
import styles from './styles.module.scss'
import InputMask from 'react-input-mask'
import {CloseIcon} from "../../../assets";
import {brigadeHours, brigadeMinutes, brigadeTypes, brigadeTypesForDp} from "../../../services/constants";

interface Props {
  brigade_type: string
  price: number,
  distance: number,
  brigade_hours: number,
  brigade_minutes: number,
  listCount: number
  isDistance: boolean
  handleInputChange: Function
  handleFormRemove: () => void
}

const BrigadeFormScheduled: FC<Props> = (props) => {

  return (
    <div id={styles.brigadeFormWrapper}>
      <div className={styles.form}>
        {props.listCount > 1 && <CloseIcon className={styles.removeIcon} onClick={props.handleFormRemove}/>}
        <p className={styles.brigadeFormTitle}>Предложение</p>
        <div className='d-flex space-between' style={{gap: 6}}>
          <Autocomplete
            className={styles.input}
            options={brigadeTypes}
            value={props.brigade_type}
            onChange={(data) => props.handleInputChange('brigade_type', data.value)}
            label={'Выбрать тип бригады'}
            optionLabel={'value'}
            optionValue={'value'}/>
          <InputMask mask="99999999999999" maskChar=" "
                     className={styles.inputPrice}
                     label='Цена'
                     onChange={e => props.handleInputChange('price', parseInt(e?.target.value))}
                     value={props.price}>
            {(inputProps) => <Input {...inputProps} />}
          </InputMask>
        </div>
        <div className='d-flex space-between' style={{gap: 6}}>

          <Autocomplete
            className={styles.input}
            options={brigadeHours}
            value={props.brigade_hours}
            onChange={(data) => props.handleInputChange('brigade_hours', data.value)}
            label={'Час'}
            optionLabel={'value'}
            optionValue={'value'}/>
          <Autocomplete
            className={styles.input}
            options={brigadeMinutes}
            value={props.brigade_minutes}
            onChange={(data) => props.handleInputChange('brigade_minutes', data.value)}
            label={'Минуты'}
            optionLabel={'value'}
            optionValue={'value'}/>
        </div>
        <div className='d-flex space-between' style={{gap: 6}}>
          <Checkbox checked={props.isDistance}
                    className={styles.checkbox}
                    onChange={(checked) => props.handleInputChange('isDistance', checked)}
                    label={'За город'}/>

         <InputMask mask="99999999999999" maskChar=" "
                                          className={styles.inputPrice}
                                          label='Километраж'
                    disabled={!props.isDistance}
                                          onChange={e => props.handleInputChange('distance', parseInt(e?.target.value))}
                                          value={props.distance}>
            {(inputProps) => <Input {...inputProps} disabled={!props.isDistance} />}
          </InputMask>
         <InputMask mask="99999999999999" maskChar=" "
                                          className={styles.inputPrice}
                                          label='Цена за 1 км'
                    disabled={!props.isDistance}
                                          onChange={e => props.handleInputChange('distance_price', parseInt(e?.target.value))}
                                          value={props.distance_price}>
            {(inputProps) => <Input {...inputProps} disabled={!props.isDistance} />}
          </InputMask>
        </div>
      </div>
    </div>
  )
}

export default BrigadeFormScheduled
